/**
 * Gets the data from the task output in a nice safe way!
 *
 *   { quote: { customerId: 'cus-1' } } + 'quote.customerId' -> 'cus-1'
 *   { quote: null }                    + 'quote.customerId' -> undefined
 */
export const readDataFromTask = ({
  source,
  path
}: {
  source: unknown
  path: string
}): unknown =>
  path.split('.').reduce<unknown>(
    // We only look at a task's own keys. Otherwise a path like
    // 'constructor.name' would find something on the prototype and hand back a
    // confident-looking answer that has nothing to do with the response.
    (value, segment) =>
      typeof value === 'object' &&
      value !== null &&
      Object.hasOwn(value, segment)
        ? (value as Record<string, unknown>)[segment]
        : undefined,
    source
  )
